import { rupees } from 'config/utils';
import sanitizePaymentOptions, {
  getSupportedPaymentInstruments,
} from './paymentOptions';

import {
  getIsMobileDevice,
} from 'utils/ModernizrUtils';

const getInstapayInitialState = (state, baseInitialState = {}) => {
  const {
    should_retry: shouldRetry,
  } = state;
  const updatedState = shouldRetry ? state.retry_data : state;
  const {
    is_rap: isRAP,
    prefilled = {},
  } = updatedState;

  const amount = shouldRetry ? state.payment.amount : prefilled.amount;

  const paymentInstruments = getSupportedPaymentInstruments(
    updatedState.payment_forms || (state.payment && state.payment.payment_forms) || {}
  );

  return {
    ...baseInitialState,
    isInstapayPayment: true,
    isRAP,
    totalAmount: amount,
    totalAmountFormatted: rupees(amount),
    selectedBankId: '',
    isMobileDevice: getIsMobileDevice(),
    ...sanitizePaymentOptions(paymentInstruments),
  };
};

export default getInstapayInitialState;



// WEBPACK FOOTER //
// ./src/payments/reducers/finalize/instapayInitialState.js